document.addEventListener("DOMContentLoaded", function () {
  const continueLink = "/pages/tagged-products";

  const productTags = (window.productTags || []).map(tag => tag.toLowerCase().trim());

  console.log("Detected product tags:", productTags);

  if (productTags.includes("customised-product-tag")) {
    const btnContainer = document.querySelector(".product-form__buttons");

    const atcButton = document.querySelector('[id^="ProductSubmitButton-"]');
    if (atcButton) {
      atcButton.style.display = "none";
    }

    if (btnContainer) {
      const continueBtn = document.createElement("a");
      continueBtn.href = "#";
      continueBtn.className = "button button--secondary w-full mt-3 continue-button";
      continueBtn.textContent = "Continue";

      // Start disabled
      continueBtn.style.pointerEvents = "none";
      continueBtn.style.opacity = "0.5";

      btnContainer.insertAdjacentElement("beforeend", continueBtn);

      const approvalCheckbox = document.querySelector("#option1");
      if (approvalCheckbox) {
        approvalCheckbox.addEventListener("change", function () {
          if (this.checked) {
            continueBtn.style.pointerEvents = "auto";
            continueBtn.style.opacity = "1";
          } else {
            continueBtn.style.pointerEvents = "none";
            continueBtn.style.opacity = "0.5";
          }
        });
      }

continueBtn.addEventListener("click", function (event) {
  event.preventDefault();

  if (approvalCheckbox && !approvalCheckbox.checked) return;

  if (atcButton) atcButton.click();
    localStorage.setItem("redirect", continueLink);
});
}}
});
